import { makeAutoObservable } from 'mobx';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastMessage {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

class ToastStore {
  toasts: ToastMessage[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  showToast(message: string, type: ToastType = 'info', duration: number = 5000) {
    const id = Date.now().toString();
    const toast: ToastMessage = { id, message, type, duration };
    this.toasts.push(toast);

    if (duration > 0) {
      setTimeout(() => {
        this.removeToast(id);
      }, duration);
    }
  }

  showSuccess(message: string, duration?: number) {
    this.showToast(message, 'success', duration);
  }

  showError(message: string, duration?: number) {
    this.showToast(message, 'error', duration);
  }

  showWarning(message: string, duration?: number) {
    this.showToast(message, 'warning', duration);
  }

  showInfo(message: string, duration?: number) {
    this.showToast(message, 'info', duration);
  }

  removeToast(id: string) {
    this.toasts = this.toasts.filter(toast => toast.id !== id);
  }

  clearAllToasts() {
    this.toasts = [];
  }
}

export const toastStore = new ToastStore();